import React from 'react';
import Card from '../../components/Card';
import { Text, TitleService } from '../../styles/typography';
import { Container, Row } from '../styles';
import { useTranslation } from 'react-i18next';

const Login: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Text style={{ marginTop: 0, marginBottom: 5 }}>4/10</Text>

      <Text style={{ marginBottom: 10, marginTop: 0 }}>
        {t('dashboard-inicial')}
      </Text>

      <TitleService style={{ marginBottom: 0 }}>
        {t('dashboard-title')} <span>{t('dashboard-title2')}</span>
      </TitleService>
      <Text style={{ marginBottom: 10, marginTop: 0 }}>
        {t('Clique para avançar de etapa')}
      </Text>

      <Row>
        <Card
          title={t('dashboard-sim')}
          name="dashboard"
          value="Sim"
          imgName={'paineladm.png'}
          path={'NivelProjeto'}
          description={t('dashboard-descript-sim')}
        />
        <Card
          title={t('dashboard-nenhum')}
          name="dashboard"
          value="Não"
          imgName={'nao.png'}
          path={'NivelProjeto'}
          description={t('dashboard-descript-nenhum')}
        />
        <Card
          title={t('dashboard-naosei')}
          name="dashboard"
          value="Não sei"
          imgName={'naosei.png'}
          path={'NivelProjeto'}
          description={t('dashboard-descript-naosei')}
        />
      </Row>
    </Container>
  );
};

export default Login;
